import {
  type SourceMappingBuildContext,
  type SourceMappingOptionGroup,
  type MappingOption,
} from '../types'

export const buildDefaultOptions = (
  context: SourceMappingBuildContext
): SourceMappingOptionGroup => {
  const { translatedLabels } = context

  const options: MappingOption[] = [
    {
      label: translatedLabels.singularPrimaryOrgCategoryLabel,
      value: 'location',
      type: 'native',
      active: true,
    },
    {
      label: translatedLabels.singularSecondaryOrgCategoryLabel,
      value: 'department',
      type: 'native',
      active: true,
    },
    {
      label: translatedLabels.billUrlLabel,
      value: 'bill_url',
      type: 'native',
      active: true,
    },
  ]

  return {
    options,
  }
}
